import { FC } from "react";
import {
  BuildingOffice2Icon,
  PhotoIcon,
  CubeIcon,
  UserCircleIcon,
} from "@heroicons/react/24/outline";

export type ImagePlaceholderVariant =
  | "default"
  | "product"
  | "project"
  | "logo";

export interface ImagePlaceholderProps {
  label?: string;
  className?: string;
  variant?: ImagePlaceholderVariant;
  compact?: boolean;
}

const icons = {
  default: PhotoIcon,
  product: CubeIcon,
  project: BuildingOffice2Icon,
  logo: UserCircleIcon,
};

const ImagePlaceholder: FC<ImagePlaceholderProps> = ({
  label,
  className = "",
  variant = "default",
  compact = false,
}) => {
  const Icon = icons[variant];

  return (
    <div
      className={`flex flex-col items-center justify-center bg-neutral-100 dark:bg-neutral-800 text-neutral-400 dark:text-neutral-500 ${className}`}
      role="img"
      aria-label={label ? `No image for ${label}` : "No image available"}
    >
      <Icon
        className={compact ? "w-8 h-8 opacity-50" : "w-10 h-10 sm:w-12 sm:h-12 opacity-45"}
        strokeWidth={1.25}
      />
      <span
        className={`mt-2 text-center font-medium text-neutral-400 dark:text-neutral-500 px-3 ${
          compact ? "text-[10px]" : "text-xs"
        }`}
      >
        No image available
      </span>
    </div>
  );
};

export default ImagePlaceholder;
